import { Stack } from 'expo-router';

/**
 * Meals sidebar stack: the dashboard (`index`) and the per-day log flow
 * (`(detail)` group, which carries its own header + full-height chrome). Lives
 * inside the `(sidebar)` group so the desktop sidebar stays visible on the log
 * screen. The AI Coach rail is declared by the `(detail)` layout (log screen
 * only), not here, so the meals index stays rail-free.
 */
export default function MealsLayout() {
  return (
    <Stack screenOptions={{ headerShown: false }}>
      <Stack.Screen name="index" />
      <Stack.Screen name="(detail)" />
    </Stack>
  );
}
